import { DataItemType } from './data-item-type';
export var DateItemOperatorType;
(function (DateItemOperatorType) {
    /**
     * 等于
     */
    DateItemOperatorType[DateItemOperatorType["Equal"] = 1] = "Equal";
    /**
     * 不等于
     */
    DateItemOperatorType[DateItemOperatorType["NotEqual"] = 2] = "NotEqual";
    /**
     * 大于
     */
    DateItemOperatorType[DateItemOperatorType["GreaterThan"] = 3] = "GreaterThan";
    /**
     * 小于
     */
    DateItemOperatorType[DateItemOperatorType["LessThan"] = 4] = "LessThan";
    /**
     * 大于等于
     */
    DateItemOperatorType[DateItemOperatorType["GreaterThanOrEqual"] = 5] = "GreaterThanOrEqual";
    /**
     * 小于等于
     */
    DateItemOperatorType[DateItemOperatorType["LessThanOrEqual"] = 6] = "LessThanOrEqual";
    /**
     * 包含
     */
    DateItemOperatorType[DateItemOperatorType["Contains"] = 7] = "Contains";
    /**
     * 不包含
     */
    DateItemOperatorType[DateItemOperatorType["NotContains"] = 8] = "NotContains";
    /**
     * 为空
     */
    DateItemOperatorType[DateItemOperatorType["IsNull"] = 9] = "IsNull";
    /**
     * 不为空
     */
    DateItemOperatorType[DateItemOperatorType["IsNotNull"] = 10] = "IsNotNull";
    /**
     * 属于
     */
    DateItemOperatorType[DateItemOperatorType["Of"] = 11] = "Of";
    /**
     * 不属于
     */
    DateItemOperatorType[DateItemOperatorType["NotOf"] = 12] = "NotOf";
    /**
     * 拥有
     */
    DateItemOperatorType[DateItemOperatorType["Have"] = 13] = "Have";
    /**
     * 不拥有
     */
    DateItemOperatorType[DateItemOperatorType["NotHave"] = 14] = "NotHave";
    /**
     * 位于
     */
    DateItemOperatorType[DateItemOperatorType["In"] = 15] = "In";
    /**
     * 不位于
     */
    DateItemOperatorType[DateItemOperatorType["NotIn"] = 16] = "NotIn";
})(DateItemOperatorType || (DateItemOperatorType = {}));
/**
 * 逻辑型数据项操作符集合
 */
export const logicDataItemOperators = [
    {
        label: '等于',
        value: DateItemOperatorType.Equal
    }
];
export const sequenceStatusOperators = [
    {
        label: '为空',
        value: DateItemOperatorType.IsNull
    }, {
        label: '不为空',
        value: DateItemOperatorType.IsNotNull
    },
    {
        label: '等于',
        value: DateItemOperatorType.Equal
    },
    {
        label: '不等于',
        value: DateItemOperatorType.NotEqual
    }
];
/**
 * 数值型数据项操作符集合
 */
export const numberDataItemOperators = [
    ...sequenceStatusOperators,
    {
        label: '大于',
        value: DateItemOperatorType.GreaterThan
    }, {
        label: '小于',
        value: DateItemOperatorType.LessThan
    }, {
        label: '大于等于',
        value: DateItemOperatorType.GreaterThanOrEqual
    }, {
        label: '小于等于',
        value: DateItemOperatorType.LessThanOrEqual
    }
];
/**
 * 文本型数据项操作符集合
 */
export const textDataItemOperators = [
    ...sequenceStatusOperators,
    {
        label: '包含',
        value: DateItemOperatorType.Contains
    }, {
        label: '不包含',
        value: DateItemOperatorType.NotContains
    }, {
        label: '位于',
        value: DateItemOperatorType.In
    }, {
        label: '不位于',
        value: DateItemOperatorType.NotIn
    }
];
/**
 * 选人数据项操作符集合
 */
export const staffDataItemOperators = [
    ...sequenceStatusOperators,
    {
        label: '为空',
        value: DateItemOperatorType.IsNull
    }, {
        label: '不为空',
        value: DateItemOperatorType.IsNotNull
    },
    {
        label: '包含',
        value: DateItemOperatorType.Contains
    }, {
        label: '不包含',
        value: DateItemOperatorType.NotContains
    }, {
        label: '位于',
        value: DateItemOperatorType.In
    }, {
        label: '不位于',
        value: DateItemOperatorType.NotIn
    }, {
        label: '属于',
        value: DateItemOperatorType.Of
    }, {
        label: '不属于',
        value: DateItemOperatorType.NotOf
    },
    {
        label: '拥有',
        value: DateItemOperatorType.Have
    }, {
        label: '不拥有',
        value: DateItemOperatorType.NotHave
    }
];
/**
 * 关联表单数据项操作符集合
 */
export const relevanceFormDataItemOperators = [
    ...sequenceStatusOperators
];
export class OperatorService {
    static findByLabel(type, label) {
        let operator;
        if (type === DataItemType.Number || type === DataItemType.Date) {
            operator = numberDataItemOperators.find((o) => o.label === label);
        }
        else if (type === DataItemType.Logic) {
            operator = logicDataItemOperators.find((o) => o.label === label);
        }
        else if (type === DataItemType.StaffSingle) {
            operator = staffDataItemOperators.find((o) => o.label === label);
        }
        else if (type === DataItemType.RelevanceForm || type === DataItemType.RelevanceFormEx) {
            operator = relevanceFormDataItemOperators.find((o) => o.label === label);
        }
        else {
            operator = textDataItemOperators.find((o) => o.label === label);
        }
        return operator;
    }
    static findByValue(type, value) {
        let operator;
        if (type === DataItemType.Number || type === DataItemType.Date) {
            operator = numberDataItemOperators.find((o) => o.value === value);
        }
        else if (type === DataItemType.Logic) {
            operator = logicDataItemOperators.find((o) => o.value === value);
        }
        else if (type === DataItemType.StaffSingle) {
            operator = staffDataItemOperators.find((o) => o.value === value);
        }
        else if (type === DataItemType.RelevanceForm || type === DataItemType.RelevanceFormEx) {
            operator = relevanceFormDataItemOperators.find((o) => o.value === value);
        }
        else {
            operator = textDataItemOperators.find((o) => o.value === value);
        }
        return operator;
    }
}
export function convertDataItemExp(json) {
    const items = JSON.parse(json);
    const text = items.map((item) => {
        let op = '';
        switch (item.op) {
            case 'Eq':
                op = '==';
                break;
            case 'NotEq':
                op = '!=';
                break;
            case 'Gt':
                op = '>';
                break;
            case 'Lt':
                op = '<';
                break;
            case 'Like':
                op = '包含';
                break;
            case 'NotLike':
                op = '不包含';
                break;
        }
        return `${item.propertyCode} ${op} {${item.propertyValue}}`;
    }).join(' && ');
    return text;
}
